<div class="rules">
  <div class="rule">
    <ng-container
      *ngTemplateOutlet="
        stateIcon;
        context: { $implicit: errors['required'] !== undefined || errors['needUpperCaseCharts'] !== undefined }
      "
    ></ng-container>
    <p>Password must include at least 1 uppercase</p>
  </div>
  <div class="rule">
    <ng-container
      *ngTemplateOutlet="
        stateIcon;
        context: { $implicit: errors['required'] !== undefined || errors['needLowerCaseCharts'] !== undefined }
      "
    ></ng-container>
    <p>Password must include at least 1 lowercase</p>
  </div>
  <div class="rule">
    <ng-container
      *ngTemplateOutlet="
        stateIcon;
        context: { $implicit: errors['required'] !== undefined || errors['needSpecialCharts'] !== undefined }
      "
    ></ng-container>
    <p>Password must include symbols (!,@,#,%...)</p>
  </div>
  <div class="rule">
    <ng-container
      *ngTemplateOutlet="
        stateIcon;
        context: { $implicit: errors['required'] !== undefined || errors['needDigitCharts'] !== undefined }
      "
    ></ng-container>
    <p>Password must include numbers</p>
  </div>
  <div class="rule">
    <ng-container
      *ngTemplateOutlet="
        stateIcon;
        context: { $implicit: errors['required'] !== undefined || errors['minlength'] !== undefined }
      "
    ></ng-container>
    <p>Length at least {{ (errors['minlength'].requiredLength | number) || minlength }} characters</p>
  </div>
</div>
<ng-template #stateIcon let-state>
  <mat-icon class="invalid" *ngIf="state; else invalid">highlight_off</mat-icon>
  <ng-template #invalid>
    <mat-icon class="valid">check_circle_outline</mat-icon>
  </ng-template>
</ng-template>
